export default __webpack_public_path__ + "static/media/bbhairshop_logo_white.647003ec.png";